<template>
  <resource-collection>
    <orders-report-button slot="before-actions" btn-class="m-1" popover-type="popover-sm popover-dark popover-bottom-left md:popover-bottom"/>
    <template slot-scope="{item}">
      <order :order="item"/>
    </template>
  </resource-collection>
</template>

<script>
import Order from './Order.vue';
import collection from '../../mixins/collection';
import ResourceCollection from '../resources/ResourceCollection.vue';
import OrdersReportButton from '../orders/OrdersReportButton.vue';

export default {
  mixins: [collection],

  components: { Order, ResourceCollection, OrdersReportButton },

  mounted() {
    Event.listen('orderUpdated', order => this.update(order));
    Event.listen('orderCreated', order => this.prepend(order));
    Event.listen('orderDeleted', order => this.remove(order));
  },
};
</script>